module.exports = __webpack_public_path__ + "static/media/Stellar Vox King Headboard - 180 cm_Black.cc71eb16.png";